export default __webpack_public_path__ + "static/media/LawTonic.a2e88f6b2f1122d507d3506a50d54dd3.webp";